<div class="p-3 bg-white dark:bg-zinc-950 shadow flex justify-end space-x-3 border-b border-zinc-950/10 dark:border-white/10">
  <select class="w-full sm:w-44 bg-white dark:bg-zinc-900 text-zinc-900 dark:text-zinc-200 border border-zinc-950/10 dark:border-white/10 rounded px-2 py-1">
    <option value="">Select Member</option>
    <option *ngFor="let company of credentialCompanies" [value]="company.id">
      {{ company.name | titlecase }}
    </option>
  </select>
</div>

<div class="relative w-full h-screen">
  <button 
    class="absolute top-3 right-14 z-20 bg-white dark:bg-zinc-950 shadow p-2 border border-zinc-950/10 dark:border-white/10"
    (click)="showMenu = !showMenu">
    <svg class="w-6 h-6 text-zinc-900 dark:text-zinc-200" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
      <path d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" 
        stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  </button>
  <div 
    *ngIf="showMenu" 
    class="absolute top-14 right-3 bg-white dark:bg-zinc-950 rounded-xl shadow-lg p-3 w-52 z-10 border border-zinc-950/10 dark:border-white/10">
    
    <div class="flex justify-between items-center py-1 text-zinc-900 dark:text-zinc-200">
      <span class="font-semibold">Auto Zoom</span>
      <button
        class="w-10 h-6 rounded-full flex items-center px-1 transition-colors"
        [class.bg-blue-500]="autoZoom"
        [class.bg-gray-300]="!autoZoom && !darkMode"
        [class.bg-zinc-700]="!autoZoom && darkMode"
        (click)="autoZoom = !autoZoom; toggleAutoZoom()">
        <div
          class="w-4 h-4 bg-white dark:bg-zinc-900 rounded-full shadow transform transition"
          [class.translate-x-4]="autoZoom"></div>
      </button>
    </div>
    <div class="flex justify-between items-center py-1 text-zinc-900 dark:text-zinc-200">
      <span class="font-semibold">Companies</span>
      <button
        class="w-10 h-6 rounded-full flex items-center px-1 transition-colors"
        [class.bg-blue-500]="showCompanies"
        [class.bg-gray-300]="!showCompanies && !darkMode"
        [class.bg-zinc-700]="!showCompanies && darkMode"
        (click)="showCompanies = !showCompanies">
        <div
          class="w-4 h-4 bg-white dark:bg-zinc-900 rounded-full shadow transform transition"
          [class.translate-x-4]="showCompanies"></div>
      </button>
    </div>
  </div>
  <!-- Google Map -->
  <google-map height="100%" width="100%" [center]="center" [zoom]="zoom">
    <ng-container *ngIf="showCompanies">
      <map-marker *ngFor="let company of credentialCompanies"
        #marker="mapMarker"
        [position]="company.address.coords"
        [title]="company.name"
        [options]="company.markerOptions"
        (mapClick)="onMarkerClick(marker, company)">
      </map-marker>
    </ng-container>

    <map-info-window>
      <h3 class="font-bold text-zinc-900 dark:text-zinc-700">Name: {{ selectedCompany?.name }}</h3>
      <p class="text-zinc-700 dark:text-zinc-700"><span class="font-semibold">Address:</span> {{ selectedCompany?.address.name }}</p>
      <p class="text-zinc-700 dark:text-zinc-700"><span class="font-semibold">Email:</span> {{ selectedCompany?.email }}</p>
      <p class="text-zinc-700 dark:text-zinc-700"><span class="font-semibold">Phone:</span> {{ selectedCompany?.phoneNumber }}</p>
    </map-info-window>
  </google-map>
</div>
